<template>
    <div>
        <div class="col-md-4 pt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':!specail&&(viewToggle||!clickToggle)}">
            <div class="risk_list">
                <ul class="list-group">
                    <li class="risk_list_tit list-group-item" style="border:none;border-top:1px solid rgba(0,0,0,.125);border-radius:0px;">
                        <i class="fa fa-institution fa-lg mr-2"></i>园区动态
                        <span class="goback" @click='goBack()' v-show="!isMap">返回</span>
                    </li>
                </ul>

                <div class="row nano p-0 m-0 one_title_nano has-scrollbar">
                    <div class="nano-content" id="home_right_list" :class="{'cur':!viewToggle}">
                        <ul class="list-unstyled">

                            <li v-for="homeList in homeLists" class="media pb-4 pt-4 pl-4 pr-3 border-bottom">

                                <img v-if="homeList.thumb!=''" class="mr-3 img-thumbnail probations_img" :src="homeList.thumb" />

                                <div class="media-body">
                                    <h5>
                                        <router-link tag="span"  class="f15 teshu  font-weight-bold" :value="homeList.id" :to ="{name:'gardenId',params :{contentid:homeList.id}}">{{ homeList.title }}</router-link>
                                        <!--<a href="#" class="f15 text-dark font-weight-bold" @click="detail(homeList.id)">{{ homeList.title }}</a>-->
                                    </h5>

                                    <div class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">
                                        <span>{{ homeList.description}}</span>
                                    </div>

                                    <div class="clearfix" style="line-height: 22px;">
                                        <div class="float-left">
                                            <span class="border border-primary text-primary f12 p-11"><a href="javascript:">{{ homeList.category.name }}</a></span>
                                        </div>
                                        <div class="float-left pr-3 pl-3" v-if="homeList.description">
                                            <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                                        </div>
                                        <div class="float-left" v-if="homeList.description">
                                            <span class="f12 text-muted">{{homeList.published}}</span>
                                        </div>
                                    </div>
                                </div>
                            </li>

                            <p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>

                        </ul>

                        <!--<p class="text-center"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>-->
                        <div v-if="homeLists&&homeLists.length ==0" class="nodata text-center">
                            <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="">
                            <p class="text-center p-2">暂无数据</p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8 pl-0 mt-3 risk_content centre_sm_none" v-if="isMap" :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'d-none':!specail&&(viewToggle||clickToggle)}" >
            <div class="right_content_show" style="background-color: white;">
                <div id="consult_left_content" class="pl-3" v-if="!viewToggle">
                    <span class="myBtn" @click='goback()'>返回</span>
                </div>
                <ul class="tab">
                    <li :class="{cur: type==1}" @click="toggleMap(1)">中国园区</li>
                    <li :class="{cur: type==2}" @click="toggleMap(2)">境外园区</li>
                </ul>
                <div class="nano one_title_nano has-scrollbar" id="barheight" v-show="isMap">
                    <div class="nano-content">
                        <div id="myChart" :class="type==2?'hidden':'show'" :style="{width:chart,height:'427px'}"></div>
                        <div id="worldChart" :class="type==1?'hidden':'show'" :style="{width:chart,height:'427px'}"></div>
                        <p class="title">{{title}}</p>
                        <ul class="areas row" v-if="areaArr&&areaArr.length>0">
                            <li class="col-md-6" v-for="(item,index) in areaArr" :key="index" @click="gotoUrl(item.url)">{{item.name}}</li>
                        </ul>
                        <div v-if="areaArr&&areaArr.length ==0" class="nodata text-center">
                            <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="">
                            <p class="text-center p-2">暂无数据</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-md-8 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'d-none':!specail&&(viewToggle||clickToggle)}" v-if="!isMap">
            <articles></articles>
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts'
    // import china from './china.js'
    // import world from './world'
    import articles from './ArticleDetails/Article.vue'
    export default({
        name: 'garden',
        data() {
            return {
                type:1,   //1境内 2 境外
                word:'china',
                title:"北京",
                isMap:true,
                chart:$(".nano-content").width()-40,
                areaArr:[],
                token: '',
                page: 0,
                total_page: 1,
                specail:false, //特殊处理 小于544px
                homeLists:[],
                viewToggle:true,
                clickToggle:true,
                barHeight:0,
                loadShow:true
            }
        },
        components: {
            articles
        },
        mounted() {
            document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
            this.load();
            var _this=this;
            this.chart=$(window).width()*11/12*3/4-40;
            this.initMap1();
            this.barHeight=$("#barheight").height();
        },
        created: function() {
            var self = this;
            this.viewToggle=this.IsPC();
            if(this.IsPC()&&(document.body.clientWidth<=700)){
                this.specail=true
            }else{
                this.specail=false
            }
            this.initList();
            //首页左侧列表请求
            this.$axios.post('/api/pc/getgardenlist', {

            }).then(data => {
                var homeLists = data.data.data.content;
                self.total_page = data.data.last_page;
                self.homeLists = homeLists;
                self.loadShow = false;

            })
        },
        computed: {
            isFollow () {
                return this.$store.state.screenWidth;
            }
        },
        watch: {
            $route: {
                handler: function(val, oldVal) {
                    var self = this;
                    let that = this;
                    this.isMap=false;
                    if(this.$route.params.contentid) {

                    } else {
                        this.$axios.post('/api/pc/gettryreadarticle', {
                            id: this.$route.params.id
                        }).then(data => {
                            var probations = data.data.data;
                            self.probations = probations;

                            //首页左侧列表请求
                            var classify = encodeURI('园区');
                            this.$axios({
                                url: 'https://recommend.imsilkroad.com/recommend/rest/tag/1/0/0/0/' + classify + '/0',
                                method: 'get',
                                headers: {
                                    token: that.token
                                }
                            }).then(data => {
                                var homeLists = data.data.results;

                                if(that.probations == '') {

                                    that.$router.push({
                                        name: 'garden',
                                        params: {
                                            contentid: homeLists[0].resourceId,
                                        }
                                    });
                                } else {
                                    that.$router.push({
                                        name: 'garden',
                                        params: {
                                            contentid: probations[0].id,
                                        }
                                    });
                                }

                            })
                        })
                    }

                },
                deep: true
            },
    isFollow (val) {
        if (!this.timer) {
            //this.screenWidths = val;
            this.timer = true;
            let that = this;
            setTimeout(function () {
                if(that.IsPC()&&(val<=700)){
                    that.specail=true
                }else{
                    that.specail=false
                }
                that.timer = false
            }, 300)
        }

    }
        },
        methods:{
            gotoUrl(url){
              window.open(url)
            },
            clickToggles(){
                this.clickToggle=false;
            },
            goback(){
                if(this.viewToggle){
                    this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:1}})
                }else{
                    this.clickToggle=true;
                }

            },
            initList(){
                var _this=this;
                this.$axios.post('/api/pc/getgarden',{province:this.title}).then(data => {
                    _this.areaArr=[];
                    if(data.data.state){
                        _this.areaArr=data.data.data;
                    }else{
                        _this.areaArr=[]
                    }

                })
            },
            detail(id){
                this.isMap=false;
                this.$router.push({name:'articleId',params :{contentid:probation.id}})
            },
            goBack(){
                var that=this;
                this.isMap=true;
                this.load();
                this.toggleMap(1);
                this.$nextTick(function(){
                    $("#barheight").height(that.barHeight+"px");
                })
            },
            toggleMap(num){
                this.type=num;
                if(num==1){
                    this.areaArr=[];
                    this.title="湖北省";
                    this.initList();
                    this.initMap1();
                }else{
                    this.areaArr=[];
                    this.title="中国";
                    this.initList();
                    this.initMap2();
                }
            },
            initMap1(){
                var mapName = 'china';
                var _this=this;
                var geoCoordMap={};
                $.get('/database/js/china.json', function (chinaJson) {
                    echarts.registerMap('china', chinaJson);
                    var mycharts = echarts.init(document.getElementById('myChart'));
                    var mapFeatures = echarts.getMap(mapName).geoJson.features;
                    mapFeatures.forEach(function(v) {
                        // 地区名称
                        var name = v.properties.name;
                        // 地区经纬度
                        geoCoordMap[name] = v.properties.cp;

                    });
                    var convertData = function(data) {
                        var res = [];
                        for (var i = 0; i < data.length; i++) {
                            var geoCoord = geoCoordMap[data[i].name];
                            if (geoCoord) {
                                res.push({
                                    name: data[i].name,
                                    value: geoCoord.concat(data[i].value),
                                });
                            }
                        }
                        return res;
                    };
                    var data = [{
                        name: "北京",
                        selected: true
                    },
                        {
                            name: "天津"
                        },
                        {
                            name: "河北"
                        },
                        {
                            name: "山西"
                        },
                        {
                            name: "内蒙古"
                        },
                        {
                            name: "辽宁"
                        },
                        {
                            name: "吉林"
                        },
                        {
                            name: "黑龙江"
                        },
                        {
                            name: "上海"
                        },
                        {
                            name: "江苏"
                        },
                        {
                            name: "浙江"
                        },
                        {
                            name: "安徽"
                        },
                        {
                            name: "福建"
                        },
                        {
                            name: "江西"
                        },
                        {
                            name: "山东"
                        },
                        {
                            name: "河南"
                        },
                        {
                            name: "湖北",

                        },
                        {
                            name: "湖南"
                        },
                        {
                            name: "重庆"
                        },
                        {
                            name: "四川"
                        },
                        {
                            name: "贵州"
                        },
                        {
                            name: "云南"
                        },
                        {
                            name: "西藏"
                        },
                        {
                            name: "陕西"
                        },
                        {
                            name: "甘肃"
                        },
                        {
                            name: "青海"
                        },
                        {
                            name: "宁夏"
                        },
                        {
                            name: "新疆",
                        },
                        {
                            name: "广东"
                        },
                        {
                            name: "广西"
                        },
                        {
                            name: "海南"
                        },
                        {
                            name: "台湾"
                        },
                        {
                            name: "南海诸岛"
                        },
                    ];
                    var  option = {
                        tooltip: {
                            trigger: 'item',
                            formatter: function(params) {
                                if (typeof(params.value)[2] == "undefined") {
                                    var toolTiphtml = '';
                                    for (var i = 0; i < data.length; i++) {
                                        if (params.name == data[i].name) {
                                            toolTiphtml += data[i].name + ''
                                        }
                                    }
                                    var toolTiphtml = '';
                                    for (var i = 0; i < data.length; i++) {
                                        if (params.name == data[i].name) {
                                            toolTiphtml += data[i].name + ''
                                        }
                                    }
                                    return toolTiphtml;
                                }
                            }
                        },
                        geo: {
                            show: true,
                            map: mapName,
                            label: {
                                normal: {
                                    show: false
                                },
                                emphasis: {
                                    show: false,
                                }
                            },
                            roam: false,
                            itemStyle: {
                                normal: {
                                    areaColor: '#7FA2DF',
                                    borderColor: '#fff',
                                },
                                emphasis: {
                                    areaColor: '#2C78DD',
                                }
                            }
                        },
                        series: [{
                            name: '散点',
                            type: 'scatter',
                            coordinateSystem: 'geo',
                            data: convertData(data),
                            symbolSize: 10,
                            label: {
                                normal: {
                                    formatter: '{b}',
                                    position: 'right',
                                    show: false
                                },
                                emphasis: {
                                    show: false
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: '#F3CA61'
                                }
                            }
                        },

                            {
                                name: '',
                                type: 'map',
                                mapType: mapName,
                                map: mapName,
                                selectedMode: 'single', //地图省市区域单选
                                label: {
                                    normal: {
                                        show: false
                                    },
                                    emphasis: {
                                        show: false,
                                        textStyle: {
                                            color: '#fff'
                                        }
                                    }
                                },
                                roam: false,
                                itemStyle: {
                                    normal: {
                                        label: {
                                            show: true
                                        },
                                        borderWidth: 1, // 省份的边框宽度
                                        borderColor: '#fff', // 省份的边框颜色
                                        areaColor: '#7FA2DF' // 设置地图颜色
                                    },
                                    emphasis: {
                                        label: {
                                            show: true
                                        },
                                        areaColor: '#2C78DD' //选中区域颜色
                                    }
                                },
                                data: data
                            },


                        ]
                    };
                    mycharts.clear();
                    mycharts.setOption(option);
                    mycharts.on('click',function (param) {
                        _this.title=param.name;
                        _this.$axios.post('/api/pc/getgarden',{province:param.name}).then(data => {
                            _this.areaArr=[];
                            if(data.data.state){
                                _this.areaArr=data.data.data;
                            }else{
                                _this.areaArr=[]
                            }

                        })
                    })
                });
                /*获取地图数据*/



            },
            initMap2(){
                var mapName = 'world';
                var _this=this;
                var geoCoordMap={};
                $.get('/database/js/world.json', function (chinaJson) {
                    echarts.registerMap('world', chinaJson);
                    var mycharts = echarts.init(document.getElementById('worldChart'));
                    var mapFeatures = echarts.getMap(mapName).geoJson.features;
                    mapFeatures.forEach(function(v) {
                        // 地区名称
                        var name = v.properties.name;
                        // 地区经纬度
                        // geoCoordMap[name] = v.properties.cp;
                        geoCoordMap[name] = "境外园区";

                    });
                    var convertData = function(data) {
                        var res = [];
                        for (var i = 0; i < data.length; i++) {
                            var geoCoord = geoCoordMap[data[i].name];
                            //var geoCoord = "境外园区";
                            if (geoCoord) {
                                res.push({
                                    name: data[i].name,
                                    value: geoCoord.concat(data[i].value),
                                });
                            }
                        }
                        return res;
                    };
                    var data=[
                            {'Afghanistan':'阿富汗'},
                            {'Angola':'安哥拉'},
                            { 'Albania':'阿尔巴尼亚'},
                            {'United Arab Emirates':'阿联酋'},
                            { 'Argentina':'阿根廷'},
                            {'Armenia':'亚美尼亚'},
                            {'French Southern and Antarctic Lands':'法属南半球和南极领地'},
                            {'Australia':'澳大利亚'},
                            {'Austria':'奥地利'},
                            {'Azerbaijan':'阿塞拜疆'},
                            { 'Burundi':'布隆迪'},
                            {'Belgium':'比利时'},
                            {'Benin':'贝宁'},
                            { 'Burkina Faso':'布基纳法索'},
                            { 'Bangladesh':'孟加拉国'},
                            { 'Bulgaria':'保加利亚'},
                            { 'The Bahamas':'巴哈马'},
                            { 'Bosnia and Herzegovina':'波斯尼亚和黑塞哥维那'},
                            { 'Belarus':'白俄罗斯'},
                            {  'Belize':'伯利兹'},
                            { 'Bermuda':'百慕大'},
                            { 'Bolivia':'玻利维亚'},
                            { 'Brazil':'巴西'},
                            { 'Brunei':'文莱'},
                            { 'Bhutan':'不丹'},
                            {'Botswana':'博茨瓦纳'},
                            { 'Central African Republic':'中非共和国'},
                            { 'Canada':'加拿大'},
                            { 'Switzerland':'瑞士'},
                            { 'Chile':'智利'},
                            { 'China':'中国',selected: true},
                            { 'Ivory Coast':'象牙海岸'},
                            { 'Cameroon':'喀麦隆'},
                            { 'Democratic Republic of the Congo':'刚果民主共和国'},
                            { 'Republic of the Congo':'刚果共和国'},
                            { 'Colombia':'哥伦比亚'},
                            { 'Costa Rica':'哥斯达黎加'},
                            { 'Cuba':'古巴'},
                            { 'Northern Cyprus':'北塞浦路斯'},
                            {'Cyprus':'塞浦路斯'},
                            { 'Czech Republic':'捷克共和国'},
                            { 'Germany':'德国'},
                            { 'Djibouti':'吉布提'},
                            { 'Denmark':'丹麦'},
                            { 'Dominican Republic':'多明尼加共和国'},
                            { 'Algeria':'阿尔及利亚'},
                            { 'Ecuador':'厄瓜多尔'},
                            {'Egypt':'埃及'},
                            {'Eritrea':'厄立特里亚'},
                            { 'Spain':'西班牙'},
                            {'Estonia':'爱沙尼亚'},
                            {'Ethiopia':'埃塞俄比亚'},
                            { 'Finland':'芬兰'},
                            { 'Fiji':'斐'},
                            { 'Falkland Islands':'福克兰群岛'},
                            { 'France':'法国'},
                            { 'Gabon':'加蓬'},
                            { 'United Kingdom':'英国'},
                            {  'Georgia':'格鲁吉亚'},
                            { 'Ghana':'加纳'},
                            { 'Guinea':'几内亚'},
                            { 'Gambia':'冈比亚'},
                            { 'Guinea Bissau':'几内亚比绍'},
                            { 'Equatorial Guinea':'赤道几内亚'},
                            { 'Greece':'希腊'},
                            { 'Greenland':'格陵兰'},
                            { 'Guatemala':'危地马拉'},
                            { 'French Guiana':'法属圭亚那'},
                            { 'Guyana':'圭亚那'},
                            { 'Honduras':'洪都拉斯'},
                            { 'Croatia':'克罗地亚'},
                            { 'Haiti':'海地'},
                            { 'Hungary':'匈牙利'},
                            { 'Indonesia':'印尼'},
                            { 'India':'印度'},
                            { 'Ireland':'爱尔兰'},
                            { 'Iran':'伊朗'},
                            {  'Iraq':'伊拉克'},
                            { 'Iceland':'冰岛'},
                            { 'Israel':'以色列'},
                            { 'Italy':'意大利'},
                            { 'Jamaica':'牙买加'},
                            { 'Jordan':'约旦'},
                            {'Japan':'日本'},
                            {'Kazakhstan':'哈萨克斯坦'},
                            { 'Kenya':'肯尼亚'},
                            { 'Kyrgyzstan':'吉尔吉斯斯坦'},
                            { 'Cambodia':'柬埔寨'},
                            { 'South Korea':'韩国'},
                            { 'Kosovo':'科索沃'},
                            { 'Kuwait':'科威特'},
                            { 'Laos':'老挝'},
                            { 'Lebanon':'黎巴嫩'},
                            { 'Liberia':'利比里亚'},
                            { 'Libya':'利比亚'},
                            { 'Sri Lanka':'斯里兰卡'},
                            { 'Lesotho':'莱索托'},
                            {  'Lithuania':'立陶宛'},
                            { 'Luxembourg':'卢森堡'},
                            { 'Latvia':'拉脱维亚'},
                            { 'Morocco':'摩洛哥'},
                            { 'Moldova':'摩尔多瓦'},
                            { 'Madagascar':'马达加斯加'},
                            { 'Mexico':'墨西哥'},
                            {  'Macedonia':'马其顿'},
                            { 'Mali':'马里'},
                            { 'Myanmar':'缅甸'},
                            { 'Montenegro':'黑山'},
                            { 'Mongolia':'蒙古'},
                            { 'Mozambique':'莫桑比克'},
                            { 'Mauritania':'毛里塔尼亚'},
                            {'Malawi':'马拉维'},
                            { 'Malaysia':'马来西亚'},
                            { 'Namibia':'纳米比亚'},
                            { 'New Caledonia':'新喀里多尼亚'},
                            { 'Niger':'尼日尔'},
                            {  'Nigeria':'尼日利亚'},
                            { 'Nicaragua':'尼加拉瓜'},
                            { 'Netherlands':'荷兰'},
                            { 'Norway':'挪威'},
                            { 'Nepal':'尼泊尔'},
                            { 'New Zealand':'新西兰'},
                            { 'Oman':'阿曼'},
                            { 'Pakistan':'巴基斯坦'},
                            { 'Panama':'巴拿马'},
                            {  'Peru':'秘鲁'},
                            {  'Philippines':'菲律宾'},
                            { 'Papua New Guinea':'巴布亚新几内亚'},
                            { 'Poland':'波兰'},
                            { 'Puerto Rico':'波多黎各'},
                            { 'North Korea':'朝鲜'},
                            { 'Portugal':'葡萄牙'},
                            {'Paraguay':'巴拉圭'},
                            { 'Qatar':'卡塔尔'},
                            { 'Romania':'罗马尼亚'},
                            { 'Russia':'俄罗斯'},
                            { 'Rwanda':'卢旺达'},
                            { 'Western Sahara':'西撒哈拉'},
                            { 'Saudi Arabia':'沙特阿拉伯'},
                            { 'Sudan':'苏丹'},
                            { 'South Sudan':'南苏丹'},
                            { 'Senegal':'塞内加尔'},
                            { 'Solomon Islands':'所罗门群岛'},
                            { 'Sierra Leone':'塞拉利昂'},
                            { 'El Salvador':'萨尔瓦多'},
                            { 'Somaliland':'索马里兰'},
                            { 'Somalia':'索马里'},
                            { 'Republic of Serbia':'塞尔维亚共和国'},
                            {'Suriname':'苏里南'},
                            { 'Slovakia':'斯洛伐克'},
                            { 'Slovenia':'斯洛文尼亚'},
                            { 'Sweden':'瑞典'},
                            { 'Swaziland':'斯威士兰'},
                            { 'Syria':'叙利亚'},
                            { 'Chad':'乍得'},
                            { 'Togo':'多哥'},
                            { 'Thailand':'泰国'},
                            { 'Tajikistan':'塔吉克斯坦'},
                            { 'Turkmenistan':'土库曼斯坦'},
                            {'East Timor':'东帝汶'},
                            { 'Trinidad and Tobago':'特里尼达和多巴哥'},
                            { 'Tunisia':'突尼斯'},
                            { 'Turkey':'土耳其'},
                            {'United Republic of Tanzania':'坦桑尼亚联合共和国'},
                            { 'Uganda':'乌干达'},
                            { 'Ukraine':'乌克兰'},
                            { 'Uruguay':'乌拉圭'},
                            { 'United States':'美国'},
                            { 'Uzbekistan':'乌兹别克斯坦'},
                            { 'Venezuela':'委内瑞拉'},
                            { 'Vietnam':'越南'},
                            { 'Vanuatu':'瓦努阿图'},
                            { 'West Bank':'西岸'},
                            { 'Yemen':'也门'},
                            { 'South Africa':'南非'},
                            { 'Zambia':'赞比亚'},
                            { 'Zimbabwe':'津巴布韦'},
                            {'W. Sahara':'西撒哈拉'},
                            {'Côte d\'Ivoire':'科特迪瓦'},
                            {'Guinea-Bissau':'几内亚比绍共和国'},
                            {'São Tomé and Principe':'圣多美和普林西比'},
                            {'Korea':'韩国'},
                            {'Dem. Rep. Korea':'朝鲜'}
                        ]
                    var  option = {
                        tooltip: {
                            trigger: 'item',
                            formatter: function (params) {
                                return params.name;// + ' : ' + params.value[2];
                            }
                        },
                        geo: {
                            mapType: 'world',
                            map: 'world',
                            roam: false,
                            label:{
                                normal: {

                                },
                                emphasis:{
                                    textStyle:{
                                        size:20,
                                        color:'#000'
                                    }
                                }
                            },
                            itemStyle: {
                                normal: {
                                    areaColor: '#71A8DE',
                                    borderWidth: 1,
                                    borderColor: '#fff'
                                },
                                emphasis: {
                                    areaColor: '#4077F5',
                                    borderWidth: 2,
                                    borderColor:'#51ffe8'
                                }
                            }
                        },
                        series: [{
                            name: '散点',
                            type: 'scatter',
                            coordinateSystem: 'geo',
                            data: convertData(data),
                            symbolSize: 10,
                            label: {
                                normal: {
                                    formatter: '{b}',
                                    position: 'right',
                                    show: false
                                },
                                emphasis: {
                                    show: false
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: '#F3CA61'
                                }
                            }
                        },

                            {
                                name: '',
                                type: 'map',
                                mapType: mapName,
                                map: mapName,
                                selectedMode: 'single', //地图省市区域单选
                                label: {
                                    normal: {
                                        show: false
                                    },
                                    emphasis: {
                                        show: false,
                                        textStyle: {
                                            color: '#fff'
                                        }
                                    }
                                },
                                roam: true,
                                itemStyle: {
                                    normal: {
                                        label: {
                                            show: true
                                        },
                                        borderWidth: 1, // 省份的边框宽度
                                        borderColor: '#fff', // 省份的边框颜色
                                        areaColor: '#7FA2DF' // 设置地图颜色
                                    },
                                    emphasis: {
                                        label: {
                                            show: true
                                        },
                                        areaColor: '#2C78DD' //选中区域颜色
                                    }
                                },
                                nameMap : {
                                    'Afghanistan':'阿富汗',
                                    'Angola':'安哥拉',
                                    'Albania':'阿尔巴尼亚',
                                    'United Arab Emirates':'阿联酋',
                                    'Argentina':'阿根廷',
                                    'Armenia':'亚美尼亚',
                                    'French Southern and Antarctic Lands':'法属南半球和南极领地',
                                    'Australia':'澳大利亚',
                                    'Austria':'奥地利',
                                    'Azerbaijan':'阿塞拜疆',
                                    'Burundi':'布隆迪',
                                    'Belgium':'比利时',
                                    'Bahamas':'巴哈马',
                                    'Benin':'贝宁',
                                    'Burkina Faso':'布基纳法索',
                                    'Bangladesh':'孟加拉国',
                                    'Czech Rep.':'捷克共和国。',
                                    'Bulgaria':'保加利亚',
                                    'Central African Rep.':'中非共和国',
                                    'The Bahamas':'巴哈马',
                                    'S. Sudan':'苏丹',
                                    'Bosnia and Herzegovina':'波斯尼亚和黑塞哥维那',
                                    'Belarus':'白俄罗斯',
                                    'Belize':'伯利兹',
                                    'Bermuda':'百慕大',
                                    'Bolivia':'玻利维亚',
                                    'Brazil':'巴西',
                                    'Brunei':'文莱',
                                    'Bhutan':'不丹',
                                    'Botswana':'博茨瓦纳',
                                    'Central African Republic':'中非共和国',
                                    'Canada':'加拿大',
                                    'Switzerland':'瑞士',
                                    'Chile':'智利',
                                    'China':'中国',
                                    'Cezch Rep':'捷克共和国',
                                    'Dem. Rep. Congo':'众议员刚果',
                                    'Congo':'刚果',
                                    'Ivory Coast':'象牙海岸',
                                    'Tanzania':'坦桑尼亚',
                                    'Serbia':'塞尔维亚',
                                    'Cameroon':'喀麦隆',
                                    'Lao PDR':'老挝人民民主共和国',
                                    'Democratic Republic of the Congo':'刚果民主共和国',
                                    'Republic of the Congo':'刚果共和国',
                                    'Colombia':'哥伦比亚',
                                    'Costa Rica':'哥斯达黎加',
                                    'Cuba':'古巴',
                                    'Northern Cyprus':'北塞浦路斯',
                                    'Cyprus':'塞浦路斯',
                                    'Czech Republic':'捷克共和国',
                                    'Germany':'德国',
                                    'Djibouti':'吉布提',
                                    'Denmark':'丹麦',
                                    'Dominican Republic':'多明尼加共和国',
                                    'Algeria':'阿尔及利亚',
                                    'Ecuador':'厄瓜多尔',
                                    'Egypt':'埃及',
                                    'Eritrea':'厄立特里亚',
                                    'Spain':'西班牙',
                                    'Estonia':'爱沙尼亚',
                                    'Ethiopia':'埃塞俄比亚',
                                    'Finland':'芬兰',
                                    'Fiji':'斐',
                                    'Falkland Islands':'福克兰群岛',
                                    'France':'法国',
                                    'Gabon':'加蓬',
                                    'United Kingdom':'英国',
                                    'Georgia':'格鲁吉亚',
                                    'Ghana':'加纳',
                                    'Guinea':'几内亚',
                                    'Gambia':'冈比亚',
                                    'Guinea Bissau':'几内亚比绍',
                                    'Equatorial Guinea':'赤道几内亚',
                                    'Greece':'希腊',
                                    'Greenland':'格陵兰',
                                    'Guatemala':'危地马拉',
                                    'French Guiana':'法属圭亚那',
                                    'Guyana':'圭亚那',
                                    'Honduras':'洪都拉斯',
                                    'Croatia':'克罗地亚',
                                    'Haiti':'海地',
                                    'Hungary':'匈牙利',
                                    'Indonesia':'印尼',
                                    'India':'印度',
                                    'Ireland':'爱尔兰',
                                    'Iran':'伊朗',
                                    'Iraq':'伊拉克',
                                    'Iceland':'冰岛',
                                    'Israel':'以色列',
                                    'Italy':'意大利',
                                    'Jamaica':'牙买加',
                                    'Jordan':'约旦',
                                    'Japan':'日本',
                                    'Kazakhstan':'哈萨克斯坦',
                                    'Kenya':'肯尼亚',
                                    'Kyrgyzstan':'吉尔吉斯斯坦',
                                    'Cambodia':'柬埔寨',
                                    'South Korea':'韩国',
                                    'Kosovo':'科索沃',
                                    'Kuwait':'科威特',
                                    'Laos':'老挝',
                                    'Lebanon':'黎巴嫩',
                                    'Liberia':'利比里亚',
                                    'Libya':'利比亚',
                                    'Sri Lanka':'斯里兰卡',
                                    'Lesotho':'莱索托',
                                    'Lithuania':'立陶宛',
                                    'Luxembourg':'卢森堡',
                                    'Latvia':'拉脱维亚',
                                    'Morocco':'摩洛哥',
                                    'Moldova':'摩尔多瓦',
                                    'Madagascar':'马达加斯加',
                                    'Mexico':'墨西哥',
                                    'Macedonia':'马其顿',
                                    'Mali':'马里',
                                    'Myanmar':'缅甸',
                                    'Montenegro':'黑山',
                                    'Mongolia':'蒙古',
                                    'Mozambique':'莫桑比克',
                                    'Mauritania':'毛里塔尼亚',
                                    'Malawi':'马拉维',
                                    'Malaysia':'马来西亚',
                                    'Namibia':'纳米比亚',
                                    'New Caledonia':'新喀里多尼亚',
                                    'Niger':'尼日尔',
                                    'Nigeria':'尼日利亚',
                                    'Nicaragua':'尼加拉瓜',
                                    'Netherlands':'荷兰',
                                    'Norway':'挪威',
                                    'Nepal':'尼泊尔',
                                    'New Zealand':'新西兰',
                                    'Oman':'阿曼',
                                    'Pakistan':'巴基斯坦',
                                    'Panama':'巴拿马',
                                    'Peru':'秘鲁',
                                    'Philippines':'菲律宾',
                                    'Papua New Guinea':'巴布亚新几内亚',
                                    'Poland':'波兰',
                                    'Puerto Rico':'波多黎各',
                                    'North Korea':'朝鲜',
                                    'Portugal':'葡萄牙',
                                    'Paraguay':'巴拉圭',
                                    'Qatar':'卡塔尔',
                                    'Romania':'罗马尼亚',
                                    'Russia':'俄罗斯',
                                    'Rwanda':'卢旺达',
                                    'Western Sahara':'西撒哈拉',
                                    'Saudi Arabia':'沙特阿拉伯',
                                    'Sudan':'苏丹',
                                    'South Sudan':'南苏丹',
                                    'Senegal':'塞内加尔',
                                    'Solomon Islands':'所罗门群岛',
                                    'Sierra Leone':'塞拉利昂',
                                    'El Salvador':'萨尔瓦多',
                                    'Somaliland':'索马里兰',
                                    'Somalia':'索马里',
                                    'Republic of Serbia':'塞尔维亚共和国',
                                    'Suriname':'苏里南',
                                    'Slovakia':'斯洛伐克',
                                    'Slovenia':'斯洛文尼亚',
                                    'Sweden':'瑞典',
                                    'Swaziland':'斯威士兰',
                                    'Syria':'叙利亚',
                                    'Chad':'乍得',
                                    'Togo':'多哥',
                                    'Thailand':'泰国',
                                    'Tajikistan':'塔吉克斯坦',
                                    'Turkmenistan':'土库曼斯坦',
                                    'East Timor':'东帝汶',
                                    'Trinidad and Tobago':'特里尼达和多巴哥',
                                    'Tunisia':'突尼斯',
                                    'Turkey':'土耳其',
                                    'United Republic of Tanzania':'坦桑尼亚联合共和国',
                                    'Uganda':'乌干达',
                                    'Ukraine':'乌克兰',
                                    'Uruguay':'乌拉圭',
                                    'United States':'美国',
                                    'Uzbekistan':'乌兹别克斯坦',
                                    'Venezuela':'委内瑞拉',
                                    'Vietnam':'越南',
                                    'Vanuatu':'瓦努阿图',
                                    'West Bank':'西岸',
                                    'Yemen':'也门',
                                    'South Africa':'南非',
                                    'Zambia':'赞比亚',
                                    'Zimbabwe':'津巴布韦',
                                    'W. Sahara':'西撒哈拉',
                                    'Côte d\'Ivoire':'科特迪瓦',
                                    'Guinea-Bissau':'几内亚比绍共和国',
                                    'São Tomé and Principe':'圣多美和普林西比',
                                    'Korea':'韩国',
                                    'Dem. Rep. Korea':'朝鲜'
                                },
                                data: data
                            }]
                    };
                    mycharts.clear();
                    mycharts.setOption(option);
                    mycharts.on('click',function (param) {
                        _this.title=param.name;
                        _this.$axios.post('/api/pc/getgarden',{province:param.name}).then(data => {
                            _this.areaArr=[];
                            if(data.data.state){
                                _this.areaArr=data.data.data;
                            }else{
                                _this.areaArr=[]
                            }
                        })
                    });
                    mycharts.on('georoam',function (param) {
                        mycharts.clear();
                        mycharts.setOption(option);
                    })
                });

            },

            handleScroll() {
                var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_right_list').scrollHeight; // 总高度
                if(((all - 20) < (top + client)) && !this.loadShow) {
                    this.page++;
                    if(this.page > this.total_page) {
                        return;
                    }
                    this.loadShow = true;
                    var self = this;
                    this.$axios.post('/api/pc/getgardenlist', {
                        page:this.page
                    }).then(data => {
                        var homeListes = data.data.data.content;
                        JSON.stringify(homeListes);
                        var new_homeLists = self.homeLists.concat(homeListes);
                        self.homeLists = new_homeLists;
                        self.total_page = data.totalPage;
                        self.loadShow = false;
                    }, function(response) {
                        console.info(response);
                        if(response) {
                            console.log("失败");
                        }
                    })
                }

            },
            timeDiff(published) {
                var now = new Date();
                var date3 = now.getTime() - published;
                //计算出相差天数
                var days = Math.floor(date3 / (24 * 3600 * 1000))
                //计算出小时数
                var hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                var minutes = Math.floor(date3 / (60 * 1000))

                if(days > 0) {
                    if(days==1){
                        return days + 'day ago';
                    }
                    return days + 'days ago';
                }

                if(hours > 0) {
                    if(hours==1){
                        return hours + 'hour ago';
                    }
                    return hours + 'hours ago';
                }

                if(minutes > 0) {
                    if(minutes==1){
                        return minutes + 'minute ago';
                    }
                    return minutes + 'minutes ago';
                }
            },
        }
    })
</script>
<style type="text/css" scoped>
    .teshu:hover{
        cursor:pointer
    }
    .column_active{
        color:#208EFF!important;
        background-color:transparent!important;
        border:none;
    }
    .hidden{
        display:none;
    }
    .show{
        display:block
    }
    #myChart,#worldChart{
        background-color:rgba(0, 0, 0, 0.05);
        margin:0 20px
    }
    .tab{
        border-bottom: 1px solid #F5F6F7;
        height: 66px;
        margin-bottom:20px;
        line-height: 66px;
    }
    .tab li{
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(133,144,166,1);
        line-height:60px;
        float: left;
    }
    .tab li:nth-child(2){
        margin-left: 40px;
    }
    .tab li:hover{
        cursor: pointer;
    }
    .tab li.cur{
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:60px;
        border-bottom: 2px solid #208EFF;
    }
    .title{
        height:25px;
        font-size:18px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:25px;
        margin-left:30px;
        margin-top:20px;
    }
    .areas{
        padding:0
    }
    .areas li:hover{
        cursor:pointer
    }
    .areas li:nth-child(even){
        border-left:1px solid #F5F6F7;
    }
    .areas li{
        text-align:center;
        border-top:1px solid #F5F6F7;
        height:3rem;
        overflow: hidden;
        font-size:14px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(74,74,74,1);
        line-height:3rem;
    }
    .goback:hover{
        cursor:pointer;
    }
    .goback{
        width:84px;
        height:30px;
        background:rgba(242,243,244,1);
        border-radius:20px;
        float:right;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
        text-align:center;
        margin-top: 5px;
    }
    .myBtn{
        width:60px;
        height:30px;
        display:block;
        position:absolute;
        top:20px;
        right:20px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
        text-align:center;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    .myBtn:hover{
        cursor:pointer;
    }
    #home_right_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
</style>
